import React from "react";
import Drawer from "@mui/material/Drawer";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {Link, useLocation} from "react-router";
import {useTheme} from "@mui/material/styles";
import {Box} from "@mui/material";
import {useAuth0} from "@auth0/auth0-react";

interface SidebarProps {
    isOpen: boolean;
    setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
    menuItems: {
        path: string;
        label: string;
        icon: React.FC;
    }[];
}

const Sidebar: React.FC<SidebarProps> = ({
                                             isOpen,
                                             menuItems,
                                             setSidebarOpen,
                                         }) => {
    const location = useLocation();
    const theme = useTheme();
    const {logout} = useAuth0();

    const handleDrawerBlur = () => {
        setSidebarOpen(false);
    };

    const fallbackMapping: Record<string, string> = {
        "/chat": "/",
    };

    const getActiveItemPath = () => {
        const activeItem = menuItems.find(
            (item) => location.pathname === item.path
        );
        if (activeItem) {
            return activeItem.path;
        } else {
            return fallbackMapping["/chat"];
        }
    };

    const activePath = getActiveItemPath();
    const isSelected = (path: string) => {
        if (activePath === "/logout") {
            logout({
                logoutParams: {returnTo: window.location.origin},
            });
        }
        return activePath === path;
    };

    return (
        <Box>
            <Drawer
                variant="permanent"
                open={isOpen}
                onClose={handleDrawerBlur}
                sx={{
                    width: isOpen ? 240 : 60,
                    flexShrink: 0,
                    "& .MuiDrawer-paper": {
                        width: isOpen ? 240 : 60,
                        transition: "width 0.3s",
                        overflowX: "hidden",
                        paddingTop: "4.4rem",
                    },
                    "@media(max-width:634px)": {
                        display: isOpen ? "block" : "none",
                        width: 0,
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: 240,
                            transition: "width 0.3s",
                            overflowX: "hidden",
                        },
                    },
                }}
            >
                <Box>
                    <List className="!pt-0">
                        { menuItems?.map((item: any) => {
                                return (
                                    <ListItem
                                        className={
                                            item.label === "My Profile" ||
                                            item.label === "Change Password" ||
                                            item.label === "Log Out"
                                                ? "md:!hidden border-b-2"
                                                : "block border-b-2"
                                        }
                                        key={item.label}
                                        disablePadding
                                        sx={{
                                            backgroundColor: isSelected(item.path)
                                                ? theme.palette.primary.main
                                                : "inherit",
                                            height: "60px",
                                        }}
                                    >
                                        <ListItemButton
                                            component={Link}
                                            to={item.path}
                                            selected={isSelected(item.path)}
                                            sx={{
                                                backgroundColor: isSelected(item.path)
                                                    ? theme.palette.action.selected
                                                    : "inherit",
                                                height: "60px",
                                            }}
                                        >
                                            <ListItemIcon>
                                                <item.icon
                                                    style={{
                                                        backgroundColor: isSelected(item.path)
                                                            ? "#fff"
                                                            : theme.palette.primary.main,
                                                    }}
                                                    fill={
                                                        isSelected(item.path)
                                                            ? theme.palette.primary.main
                                                            : "#fff"
                                                    }
                                                />
                                            </ListItemIcon>
                                            {isOpen && (
                                                <ListItemText
                                                    primary={item.label}
                                                    sx={{
                                                        color: isSelected(item.path) ? "#fff" : "inherit",
                                                    }}
                                                />
                                            )}
                                        </ListItemButton>
                                    </ListItem>
                                );
                            })}
                    </List>
                </Box>
            </Drawer>
        </Box>
    );
};
export default Sidebar;
